import { css, CSSResult } from 'lit';

export const tableCss: CSSResult = css`
  /*
    TODO: Table styles
    scope to table web component tag
   */
`;
